import React from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class DuplicatesTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selection: []
        }
    }

    toggleSelection = applicantId => {
        let selection = [...this.state.selection];
        selection = selection.indexOf(applicantId) >= 0
            ? selection.filter(i => i !== applicantId)
            : [...selection, applicantId];
        this.setState({ selection });
    }

    render() {
        const { recipients, resolving, error } = this.props;
        const { selection } = this.state;

        return (
            <tr className="table-row">
                <td data-label="Name">
                    {recipients.map(recipient =>
                        <div key={recipient.applicantId} style={{display: "flex", alignItems: "center", marginBottom: "8px"}}>
                            <div className={`custom-check-container
                            ${selection.indexOf(recipient.applicantId) < 0 && selection.length === 2 ? "disabled" : ""}`}>
                                <input type="checkbox" id={`select-${recipient.applicantId}`}
                                    className="custom-check"
                                    checked={selection.indexOf(recipient.applicantId) >= 0}
                                    onChange={() => this.toggleSelection(recipient.applicantId)}
                                    disabled={selection.indexOf(recipient.applicantId) < 0 && selection.length === 2} />
                                <label htmlFor={`select-${recipient.applicantId}`} className="secondary-text" />
                            </div>
                            <p className="bold-text relative" style={{marginTop: "0"}}>
                                <i className="icons ion-ios-person-outline" style={{fontSize: "20px", verticalAlign: "middle", marginRight: "8px"}}></i>
                                {recipient.name}
                                <Link className="btn btn-primary btn-xs" target={"_blank"} to={`/recipient-accounts/${recipient.applicantId}`} style={{height: "20px", lineHeight: "20px", marginLeft: "8px", minWidth: "auto"}}>View</Link>
                            </p>
                        </div>)}
                </td>
                <td data-label="Address">
                    {recipients.map(recipient =>
                        <p key={recipient.applicantId} className="relative icon-left-text">
                            <i className="icons ion-ios-home-outline"></i>
                            {recipient.address}
                        </p>)}
                </td>
                <td data-label="Phone">
                    {recipients.map(recipient =>
                        <p key={recipient.applicantId} className="relative icon-left-text">
                            <i className="icons ion-ios-telephone-outline"></i>
                            {recipient.phoneNumber}
                        </p>)}
                </td>
                <td className="text-right">
                    {resolving ? <LoadingSpinner height="32" alignRight={true} /> :
                        <div>
                            <button className="btn btn-primary btn-small" disabled={selection.length !== 2}
                                onClick={() => this.props.viewDuplicatesDetails(selection)}>Merge</button>
                        </div>}
                    <FadeOutErrorMessage show={error} />
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/manageDuplicates/DuplicatesTableRow.jsx